import LoadingAnimation from '@/components/LoadingAnimation/LoadingAnimation'
import DeviceSuggestionCard from '@/app/pages/utility-program/unenroll/suggestions/components/DeviceSuggestionCard'
import ConfigureDeviceStepBody from '../components/ConfigureDeviceStepBody'
import ProgramPrescribedAlert from '../components/ProgramPrescribedAlert'
import useConfigureChargerViewModel from './ConfigureCharger.viewmodel'
import { logException } from '@/logging/sentry'

const { SettingsSuggestions, SuggestionCard, SuggestionDescription } =
  DeviceSuggestionCard

export default function ConfigureCharger() {
  const {
    isLoadingOrIdle,
    displayName,
    goalsValueText,
    hasPrescribedGoal,
    prescribedGoalLabels,
    settingPaths,
  } = useConfigureChargerViewModel()

  if (isLoadingOrIdle) {
    return (
      <div className="flex justify-center items-center h-full">
        <LoadingAnimation type="falling" />
      </div>
    )
  }

  // Defensive: shared `usePrescribedChargers` already filters out chargers
  // without a prescribed goal, so reaching this branch indicates a bug —
  // render nothing rather than crash.
  if (!hasPrescribedGoal) {
    logException(
      new Error(
        'ConfigureCharger rendered for a charger with no prescribed goal',
      ),
    )
    return null
  }

  return (
    <ConfigureDeviceStepBody>
      <DeviceSuggestionCard iconName="Zap" title={displayName} articles={[]}>
        <SettingsSuggestions>
          <SuggestionCard
            iconName="Target"
            title="Charging Preferences"
            destinationPath={settingPaths.chargingPreferences}
          >
            <SuggestionDescription>
              Set charging goals with Optiwatt. Tell us what matters most to you
            </SuggestionDescription>
            <SuggestionDescription>{goalsValueText}</SuggestionDescription>
          </SuggestionCard>
          {prescribedGoalLabels.map((label) => (
            <ProgramPrescribedAlert key={label} settingDisplayName={label} />
          ))}
        </SettingsSuggestions>
      </DeviceSuggestionCard>
    </ConfigureDeviceStepBody>
  )
}
